export const MealPlanDayIcon = {
  transclude: true,

  bindings: {
    count: '<',
    isSwapping: '<',
    isActive: '<',
  },

  template: `
    <div class="meal-plan-day-icon text-white"
      ng-class="{ 'bg-teal-dark': $ctrl.isActive }">
      <span class="text-uppercase ml-1"
        ng-hide="$ctrl.isSwapping"
        ng-transclude>
      </span>
      <small>
        <i ng-show="$ctrl.isSwapping" class="fa fa-refresh fa-spin fa-2x"></i>
      </small>
      <span class="badge badge-pill badge-success text-center">
         {{ $ctrl.count }}
      </span>
    </div>
  </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanDayIcon.js